import React, { useState, useEffect } from 'react';
import { useFamily } from '../context/FamilyContext';
import { subscribeToActivities } from '@coparent/shared/src/services/activityService';
import ActivityList from '../components/activities/ActivityList';
import ActivityForm from '../components/activities/ActivityForm';
import { HiPlus } from 'react-icons/hi';
import NotificationBell from '../components/notifications/NotificationBell';

const ActivitiesPage = () => {
  const { familyId } = useFamily();
  const [activities, setActivities] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingActivity, setEditingActivity] = useState(null);

  useEffect(() => {
    if (!familyId) return;
    const unsub = subscribeToActivities(familyId, setActivities);
    return unsub;
  }, [familyId]);

  const handleEdit = (activity) => {
    setEditingActivity(activity);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setEditingActivity(null);
  };

  return (
    <div className="animate-fade-in">
      <div className="flex items-center justify-between page-header">
        <div>
          <h1 className="page-title">Activities & Events</h1>
          <p className="page-subtitle">Manage recurring activities and one-off events</p>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={() => { setEditingActivity(null); setShowForm(true); }}
            className="btn-primary flex items-center gap-2 text-sm"
          >
            <HiPlus className="text-base" />
            Add Activity
          </button>
          <NotificationBell />
        </div>
      </div>

      <ActivityList activities={activities} onEdit={handleEdit} />

      {showForm && (
        <ActivityForm
          key={editingActivity?.id || 'new'}
          onClose={handleCloseForm}
          activity={editingActivity}
        />
      )}
    </div>
  );
};

export default ActivitiesPage;
